import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Table from "../../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';


const PmsTenantBooking = () => {
    const [loading, setLoading] = useState(false)
    const [allItemList, setAllItemList] = useState<any[]>([])
    // console.log("alli item list booking data", allItemList)


    const columns = [
        {
            title: "Sr No.",
            dataIndex: "SrNo",
            render: (text: string, record: any, index: number) => (
                <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
            ),
            sorter: false,
        },
        {
            title: "Booking Status",
            dataIndex: "booking_status",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" style={{ width: "max-content" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.activity_name || "").localeCompare(b.activity_name || ""),
        },
        {
            title: "Check-in Date",
            dataIndex: "actual_check_in_date",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "max-content" }}>{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.actual_check_in_date || "").localeCompare(b.actual_check_in_date || ""),
        },
        {
            title: "Check-out Date",
            dataIndex: "actual_check_out_date",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "max-content" }}>{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.actual_check_out_date || "").localeCompare(b.actual_check_out_date || ""),
        },
        {
            title: "Approval Status",
            dataIndex: "approval_status",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.approval_status || "").localeCompare(b.approval_status || ""),
        },
        {
            title: "Security Amount",
            dataIndex: "security_deposit_amount",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.security_deposit_amount - (b.security_deposit_amount),
        },
        {
            title: "Rental Amount",
            dataIndex: "rental_amount",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.rental_amount - (b.rental_amount),
        },
        {
            title: "Maintenance",
            dataIndex: "maintainance_amt",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.maintainance_amt) - (b.maintainance_amt),
        },
        {
            title: "Notice Period(months)",
            dataIndex: "notice_period_months",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.notice_period_months || "").localeCompare(b.notice_period_months || ""),
        },
        // {
        //     title: "Country",
        //     dataIndex: "contact_phone",
        //     sorter: (a: any, b: any) => a.contact_phone.localeCompare(b.contact_phone),
        // },
        // {
        //     title: "Country",
        //     dataIndex: "contact_phone",
        //     sorter: (a: any, b: any) => a.contact_phone.localeCompare(b.contact_phone),
        // },
        // {
        //     title: "Action",
        //     dataIndex: "actions",
        //     render: (_: any, record: any) => (
        //         <div className="action-icon d-inline-flex">
        //             <Link
        //                 to="#"
        //                 className="me-2"
        //             >
        //                 <i className="ti ti-edit" />
        //             </Link>
        //             <Link
        //                 to="#"
        //             >
        //                 <i className="ti ti-trash" />
        //             </Link>
        //         </div>
        //     ),
        // },
    ];

    const fetchData = async () => {
        try {
            setLoading(true);
            const resp = await AXIOSCONFIGMETHOD("get", webServiceUrl.GET_TENANT_BOOKING);
            // console.log(resp?.data?.data, " get tenant booking")
            if (resp?.data?.status) {
                console.log("arjun")
                const final = resp?.data?.data;
                // console.log("final data ", final)
                setAllItemList(final?.length > 0 && final);
                // setAllItemList(final);
            }
        } catch (error) {
            console.error("Error fetching  data:", error);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Pms Tenant Booking</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        All Pms Tenant Booking
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Pms Tenant Booking List</h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={allItemList} rowKeyId={"booking_id"} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default PmsTenantBooking
